import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import axios from 'axios';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';


// Configuração Global do Axios para Interceptar e Adicionar o Token JWT
axios.interceptors.request.use(
  (config) => {
    const authData = localStorage.getItem('zapshop_auth');
    if (authData) {
      try {
        const { token } = JSON.parse(authData);
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('Erro ao ler token da sessão', err);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import PublicStore from './pages/PublicStore';
import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import CheckoutPage from './pages/CheckoutPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CookieConsent from './components/CookieConsent';

// Proteção de Rota
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  return isAuthenticated() ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            {/* Rota 1: Landing Page (Raiz) ou Vitrine (se for Domínio Próprio) */}
            <Route
              path="/"
              element={
                window.location.hostname !== 'zapshop.app' &&
                  window.location.hostname !== 'localhost'
                  ? <PublicStore />
                  : <LandingPage />
              }
            />

            {/* Rota 2: Login do Lojista */}
            <Route path="/login" element={<LoginPage />} />

            {/* Rota 2.1: Registro de Novo Lojista */}
            <Route path="/register" element={<RegisterPage />} />

            {/* Rota 2.2: Checkout de Assinatura */}
            <Route path="/checkout" element={<CheckoutPage />} />

            {/* Rota 2.5: Redefinição de Senha */}
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Rota 3: Vitrine Pública da Loja (URL Limpa) */}
            {/* Suporta tanto UUID quanto Slug amigável */}
            <Route path="/store/:tenantId" element={<PublicStore />} />
            <Route path="/l/:tenantId" element={<PublicStore />} />

            {/* Rota 4: Painel Administrativo (Protegido) */}
            <Route
              path="/admin/*"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />

            {/* Rota de Erro 404 */}
            <Route path="*" element={<div className="p-10 text-center font-sans text-gray-500">Página não encontrada (404)</div>} />
          </Routes>
        </BrowserRouter>
        <CookieConsent />
      </ConfirmProvider>
    </ToastProvider>
  );
}

export default App;
